import { createContext } from "react";
import { VerificationDTO } from "../../../../../../../store/verification/models/dto/due-diligence";
import { DueDiligenceFileCategory } from "../../../../../../../store/verification/models/internal";

interface FileAttachmentContext {
  files: Partial<
    Record<
      typeof DueDiligenceFileCategory.T,
      VerificationDTO.Requests.DueDiligence.Form.Post.Attachments.T
    >
  >;
  setFile: (
    type: typeof DueDiligenceFileCategory.T,
    file: VerificationDTO.Requests.DueDiligence.Form.Post.Attachments.T
  ) => void;
  emailAddress?: string;
}

export const FileAttachmentContext = createContext<FileAttachmentContext>(
  (undefined as any) as FileAttachmentContext
);
